export const assignRoleToUsers = /* GraphQL */ `
  mutation assignRoleToUsers($input: AssignRoleToUsersInput!) {
  assignRoleToUsers(input: $input) {
      created
      deleted
      success
  }
}
`;

export const assignRolesToUser = /* GraphQL */ `
  mutation assignRolesToUser($input: AssignRolesToUserInput!) {
  assignRolesToUser(input: $input) {
      created
      deleted
      success
  }
}
`;

export const assignSectionToRoles = /* GraphQL */ `
  mutation assignSectionToRoles($input: AssignSectionToRolesInput!) {
  assignSectionToRoles(input: $input) {
      created
      deleted
      success
  }
}
`;

export const assignTaskListUnitToRoles = /* GraphQL */ `
  mutation assignTaskListUnitToRoles($input: AssignTaskListUnitToRolesInput!) {
  assignTaskListUnitToRoles(input: $input) {
      created
      deleted
      success
  }
}
`;

export const assignTestToRoles = /* GraphQL */ `
  mutation assignTestToRoles($input: AssignTestToRolesInput!) {
  assignTestToRoles(input: $input) {
      created
      deleted
      success
  }
}
`;

export const createMcpAccessToken = /* GraphQL */ `
  mutation createMcpAccessToken($input: CreateMcpAccessTokenInput!) {
  createMcpAccessToken(input: $input) {
      accessToken {
        createdAt
        expiresAt
        id
        lastUsedAt
        name
        revokedAt
      }
      token
  }
}
`;

export const createRole = /* GraphQL */ `
  mutation createRole($input: CreateRoleInput!) {
  createRole(input: $input) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const deleteRole = /* GraphQL */ `
  mutation deleteRole($input: DeleteRoleInput!) {
  deleteRole(input: $input) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const manageClientUserAccess = /* GraphQL */ `
  mutation manageClientUserAccess($input: ManageClientUserAccessInput!) {
  manageClientUserAccess(input: $input) {
      message
      success
  }
}
`;

export const revokeMcpAccessToken = /* GraphQL */ `
  mutation revokeMcpAccessToken($id: ID!) {
  revokeMcpAccessToken(id: $id) {
      createdAt
      expiresAt
      id
      lastUsedAt
      name
      revokedAt
  }
}
`;

export const saveRole = /* GraphQL */ `
  mutation saveRole($input: SaveRoleInput!) {
  saveRole(input: $input) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const updateRole = /* GraphQL */ `
  mutation updateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;
